var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "800",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": _vm.close
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_vm.fab ? _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "primary",
            "elevation": "6",
            "fab": "",
            "fixed": "",
            "bottom": "",
            "right": "",
            "loading": _vm.loading
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v(" mdi-plus ")])], 1) : _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "loading": _vm.loading
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v(" mdi-plus ")])], 1)];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    style: "color:white"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.thg.ThgMeterReadingForm.btnTextAlt")))]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-card-text', [_c('thg-meter-reading-form', {
    ref: "form",
    attrs: {
      "chargingStationId": _vm.chargingStation.id,
      "isSaving": _vm.loading
    },
    on: {
      "save": _vm.save
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }